import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { Check, Circle, Package, Scissors, Shirt, Sparkles, ShieldCheck, Box, MapPin, Truck, Home } from 'lucide-react';

const ICONS = {
  order_received: Package,
  fabric_reserved: Box,
  pattern_cutting: Scissors,
  sewn: Shirt,
  embroidery: Sparkles,
  quality_control: ShieldCheck,
  packed: Box,
  courier_booked: MapPin,
  in_transit: Truck,
  delivered: Home,
};

export default function Production() {
  const [stages, setStages] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get('/founders/production'); setStages(data.stages || []); })(); }, []);
  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow">Track My Tracksuit</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Production timeline</div>
        <div className="text-sm opacity-80 mt-1" style={{ color: 'var(--heritage-plum)' }}>Every stage is confirmed by the atelier as your garment moves through production.</div>
      </Panel>

      <Panel className="p-6">
        <ol className="relative">
          {stages.map((s, i) => {
            const Icon = ICONS[s.stage_key] || Circle;
            const done = s.completed;
            return (
              <li key={s.id} className="flex gap-4 items-start pb-6">
                <div className="flex flex-col items-center">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center`}
                       style={{ background: done ? 'var(--heritage-plum)' : 'transparent', color: done ? 'var(--heritage-cream)' : 'var(--heritage-plum)', border: `2px solid var(--heritage-plum)` }}>
                    {done ? <Check size={16} /> : <Icon size={16} />}
                  </div>
                  {i < stages.length - 1 && <div className="w-px flex-1 my-1" style={{ background: done ? 'var(--heritage-plum)' : 'rgba(75,24,56,0.25)' }} />}
                </div>
                <div className="pb-4 flex-1">
                  <div className="h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>{s.stage_label}</div>
                  <div className="text-sm opacity-80" style={{ color: 'var(--heritage-plum)' }}>
                    {done ? `Completed ${(s.completed_at || '').slice(0, 10)}` : 'Awaiting production'}
                  </div>
                  {s.note && <div className="text-sm mt-1 italic" style={{ color: 'var(--heritage-plum)' }}>“{s.note}”</div>}
                  {s.photo_base64 && (
                    <img src={s.photo_base64.startsWith('data:') ? s.photo_base64 : `data:image/png;base64,${s.photo_base64}`}
                         alt="" className="mt-2 w-64 rounded-lg" />
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      </Panel>
    </div>
  );
}
